import { render } from "./StylistDashboard.vue?vue&type=template&id=5b826a00&scoped=true"
import script from "./StylistDashboard.vue?vue&type=script&lang=js"
export * from "./StylistDashboard.vue?vue&type=script&lang=js"

import "./StylistDashboard.vue?vue&type=style&index=0&id=5b826a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b826a00"]])

export default __exports__